// EmptyState.jsx
import React from "react";

export function EmptyState() {
  return (
    <div className="text-center py-8 text-gray-500">
      <div className="mx-auto mb-3 text-4xl text-gray-300">📊</div>
      <p className="text-lg mb-2">No KPI codes added yet.</p>
      <p className="text-sm text-gray-400">
        Use the form above to add your first KPI code.
      </p>
    </div>
  );
}